import { Directive, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProcessingStatus } from 'src/app/core/enums/lead/processing-status.enum';
import { LeadHead } from 'src/app/core/models/lead/lead-head.model';

@Directive({
    selector: '[appLeadInfoIcon]',
    standalone: false
})
export class LeadInfoIconDirective implements OnChanges {


  @Input() set lead(lead: LeadHead) {
    this._lead = lead
    this.iconType = this.getIconType(lead, this.isAutoOfferPending)
  }

  @Input() isAutoOfferPending: boolean = false

  @HostBinding('innerHTML') iconType = '';

  private _lead: LeadHead | undefined

  ngOnChanges(changes: SimpleChanges): void {
    this.iconType = this.getIconType(this._lead!, this.isAutoOfferPending)
  }

  private getIconType(lead: LeadHead, isAutoOfferPending: boolean = false): string {
    if ([ProcessingStatus.ToDo, ProcessingStatus.WaitingReview, ProcessingStatus.Qualifiable].includes(lead.processingStatus) && !isAutoOfferPending)
      return 'edit_note'
    else return 'notes'
  }

}
